module.exports = __webpack_public_path__ + "static/03-holly-cholla-zoom-6338a58da4ffd24c9b96d37b6198424c.jpg";